/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSupportArticleForTransactionRequest} from '@cash-web/protos/squareup/cash/supportarticles/app/v1beta1/app.pb'
import {GetSupportArticleForTransactionResponse} from '@cash-web/protos/squareup/cash/supportarticles/app/v1beta1/app.pb'


export const getSupportArticleForTransaction = (request:GetSupportArticleForTransactionRequest, options?: CashRequestOptions) => post<GetSupportArticleForTransactionRequest, GetSupportArticleForTransactionResponse>("/2.0/cash/get-support-article-for-transaction", request, {...options, rejectOnError: true })